<template>
  <div class="user_container">
    <div class="goback">
      <!-- <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div> -->
    </div>
    <div class="content">
      <div class="activity_title">活动时间：</div>
      <div class="activity_time">
        {{ activityDetail.startTime }} - {{ activityDetail.endTime }}
      </div>

      <div class="step">
        <van-steps :active="active" direction="vertical">
          <van-step v-for="(step, index) in steps" :key="index">
            <!-- 未激活 -->
            <template #inactive-icon>
              <div :class="['icon', active == 1 ? 'green' : 'grey']"></div>
            </template>
            <!-- 已激活 -->
            <template #active-icon>
              <div class="icon green"></div>
            </template>
            <div>
              {{ step.name }}：<span>{{ step.time || "--" }}</span>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="sign">
        <div class="outer_ring outer" v-if="signInDetail?.signInStart == 2||!signInDetail">
          <div class="outer_center outer">
            <div class="outer_inner outer" @click="handlesignInCode">签到</div>
          </div>
        </div>
        <div
          class="outer_ring outer"
          v-if="activityDetail.signInType == 2 && signInDetail?.signInStart == 1"
        >
          <div class="outer_center outer">
            <div class="outer_inner outer" @click="handlesignOut">签退</div>
          </div>
        </div>
      </div>
      <div class="sign_text">
        <i><van-icon name="location-o" /></i>
        <div>签到地点：</div>
        <div>{{ activityDetail.place }}</div>
      </div>
    </div>
    <van-dialog
      v-model="showSignIn"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <div class="dialog_header_con">您是否确认签到？</div>
      <div class="dialog_footer1">
        <el-button @click="cancleSignIn">取消</el-button>
        <el-button @click="submitSignIn">确认</el-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSignOut"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <div class="dialog_header_con">您是否确认签退？</div>
      <div class="dialog_footer1">
        <el-button @click="cancleSignOut">取消</el-button>
        <el-button @click="submitSignOut">确认</el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      active: -1,
      steps: [
        { name: "签到时间", time: null },
        { name: "签退时间", time: null }
      ],
      activityDetail: {},
      activeTime: "",
      signInCode: "",
      signInDetail: {},
      showSignIn: false,
      showSignOut: false
    };
  },
  created() {},
  mounted() {
    this.pubBenefitDetail();
    this.querygetSignInCodes();
    this.queryMyEbpInfoApi();
    setInterval(() => {
      this.querygetSignInCodes();
    }, 120000);
  },
  methods: {
    //返回上一页
    goback() {
      this.$router.go(-1);
    },
    //是否签到签退
    queryMyEbpInfoApi() {
      api
        .pubBenefitMyEbpInfoApi({
          activityId: this.$route.query.id,
          empNo: this.$store.state.userInfo.username,
        })
        .then(data => {
          if (data.code == 200) {
            this.steps[0].time = data.data?.signInStartTime
              ? moment(data.data?.signInStartTime).format("YYYY-MM-DD HH:mm:ss")
              : null;
            this.steps[1].time = data.data?.signInEndTime
              ? moment(data.data?.signInEndTime).format("YYYY-MM-DD HH:mm:ss")
              : null;
            this.active = data.data?.signInStart == 1 ? 0 : -1;
            if (data.data?.signInStart == 1) {
              this.active = 0;
            }
            if (data.data?.signInStart == 1 && data.data?.signInEnd == 1) {
              this.active = 1;
            }
            this.signInDetail = data.data;
          }
        });
    },
    // 获取code
    querygetSignInCodes() {
      api.getSignInCodesApi({ activityId: this.$route.query.id }).then(data => {
        if (data.code == 200) {
          this.signInCode = data.data;
        }
      });
    },
    // 获取好的详情
    pubBenefitDetail() {
      api.pubBenefitDetailApi({ id: this.$route.query.id }).then(data => {
        if (data.code == 200) {
          this.activityDetail = data.data;
          this.activityDetail.startTime = moment(data.data.startTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.activityDetail.endTime = moment(data.data.endTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
      });
    },
    //签到
    handlesignInCode() {
      this.showSignIn = true;
    },
    //签到取消
    cancleSignIn() {
      this.showSignIn = false;
    },
    //签到确认
    submitSignIn() {
      
      api 
        .pubBenefitSignInApi({
          activityId: this.$route.query.id,
          empNo: this.$store.state.userInfo.username,
          code: this.signInCode
        })
        .then(data => {
          if (data.code == 200) {
            this.queryMyEbpInfoApi();
            this.$message({
              message: "签到成功",
              type: "success"
            });
            this.showSignIn = false;
          }
        })
        .catch(() => {
          this.showSignIn = false;
        });
    },
    //签退
    handlesignOut() {
      this.showSignOut = true;
    },
    //签退取消
    cancleSignOut() {
      this.showSignOut = false;
    },
    //签退确认
    submitSignOut() {
      api
        .pubBenefitSignOutApi({
          activityId: this.$route.query.id,
          empNo: this.$store.state.userInfo.username,
        })
        .then(data => {
          if (data.code == 200) {
            this.queryMyEbpInfoApi();
            this.$message({
              message: "签退成功",
              type: "success"
            });
            this.showSignOut = false;
          }
        })
        .catch(() => {
          this.showSignOut = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .content {
    margin-top: 30px;
    padding-left: 30px;
    .activity_title {
      font-size: 12px * $zoom;
      color: #000;
      font-weight: 500;
    }
    .activity_time {
      font-size: 10px * $zoom;
      color: #000;
      font-weight: 500;
      margin-top: 10px;
    }
    .step {
      margin-top: 30px;
      margin-left: -20px;
      .van-steps {
        background: none;
      }
      .green {
        width: 28px;
        height: 28px;
        background: #fff;
        border: 6px solid #29ca9c;
        border-radius: 50%;
      }
      .grey {
        width: 28px;
        height: 28px;
        background: #fff;
        border: 6px solid #969b9e;
        border-radius: 50%;
      }
      ::v-deep {
        .van-step__line {
          background: #666 !important;
        }
        .van-step__title--active {
          color: #666;
        }
        .van-step__title {
          margin-left: 20px;
        }
        .van-step--vertical {
          padding: 20px 20px 70px 0;
          font-size: 10px * $zoom;
          color: #666666;
          span {
            color: #000;
          }
        }
      }
    }
    .sign {
      display: flex;
      justify-content: center;
      margin: 20px auto 40px;
    }
    .outer {
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .outer_ring {
      background: rgba(41, 202, 156, 0.1);
      width: 300px;
      height: 300px;
      .outer_center {
        background: rgba(41, 202, 156, 0.12);
        width: 260px;
        height: 260px;
        .outer_inner {
          background: rgba(41, 202, 156, 1);
          width: 220px;
          height: 220px;
          color: #fff;
          font-size: 13px * $zoom;
        }
      }
    }
    .sign_text {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      font-size: 12px * $zoom;
      i {
        margin-right: 10px;
        margin-top: 4px;
        color: #272636;
      }

      div:nth-child(2) {
        color: #999999;
         white-space: nowrap;
      }
    }
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.dialog_header_con {
  width: 100%;
  padding: 60px 25px;
  text-align: center;
}
.dialog_footer1 {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 35%;
    height: 65px;
    font-size: 10px * $zoom;
    border-radius: 15px;
  }
  button:nth-child(1) {
    border: 1px solid #999999;
    background: #fff;
    color: #999999;
  }
  button:nth-child(2) {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
}
</style>
